import { Download } from 'lucide-react'

interface DrillDownRowProps {
  label: string
  count?: number
  total?: number
  filter: string
  auditId: string
  severity?: 'critical' | 'warning' | 'info'
}

export function DrillDownRow({ label, count = 0, total = 0, filter, auditId, severity = 'info' }: DrillDownRowProps) {
  const pct = total > 0 ? ((count / total) * 100) : 0
  const pctDisplay = pct < 0.1 && count > 0 ? '<0.1' : pct < 1 ? pct.toFixed(1) : Math.round(pct).toString()

  const colors = {
    critical: { dot: 'bg-red-500', text: 'text-red-400', badge: 'bg-red-500/10 text-red-500' },
    warning: { dot: 'bg-amber-500', text: 'text-amber-400', badge: 'bg-amber-500/10 text-amber-500' },
    info: { dot: 'bg-cyan-500', text: 'text-cyan-400', badge: 'bg-cyan-500/10 text-cyan-500' },
  }
  const c = colors[severity]

  const handleCsv = () => {
    window.open(`/api/audits/${auditId}/pages?filter=${filter}&format=csv`, '_blank')
  }

  return (
    <div className="flex items-center gap-3 py-2.5 group border-b border-[#F4F5FA] last:border-b-0">
      <span className={`w-2 h-2 rounded-full flex-shrink-0 ${c.dot}`} />
      <span className="text-sm text-[#1B2559] flex-1">{label}</span>
      <span className={`text-xs font-mono px-2 py-0.5 rounded-full ${c.badge}`}>{pctDisplay}%</span>
      <span className={`text-sm font-mono font-semibold w-16 text-right ${c.text}`}>{count.toLocaleString()}</span>
      <button
        onClick={handleCsv}
        className="opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-[#F4F5FA] rounded"
        title="Exporter CSV"
      >
        <Download className="w-3.5 h-3.5 text-[#555A73]" strokeWidth={1.25} />
      </button>
    </div>
  )
}
